import React, { useEffect, useState } from "react"
import axios from "axios"
import {
  Card,
  CardBody,
  Input,
  CardImg,
  Modal,
  Form,
  Label,
  FormGroup,
  Button,
  ModalBody,
  Row,
  ModalHeader,
  Col,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import moment from "moment/moment"
import { toast, ToastContainer } from "react-toastify"

const MyModal2 = ({ modal, toggle, values, setSubmitted }) => {
  const [formData, setFormData] = useState({
    blood_group: "",
    emergName1: "",
    emergNo1: "",
  })

  useEffect(() => {
    setFormData(values)
  }, [values])

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleUpdate = async () => {
    try {
      setSubmitted(false)

      const data = {
        sid: localStorage.getItem("sid")?.replace(/"/g, ""),
        user_id: localStorage.getItem("user_id"),
        tablename: "k6kb9_pri_staff_details",
        columns: formData,
      }

      await axios.post(
        "https://marcopolo.prisms.in/api/information/update/staff",
        data
      )

      toast.success("Updated Successfully ✅")
      setSubmitted(true)
      toggle()
    } catch (error) {
      console.error("Update failed:", error)
      toast.error("Update failed ❌")
    }
  }

  return (
    <Modal isOpen={modal} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Edit Personal Details</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Col>
              <Label>Select Blood Group</Label>

              <Input
                type="select"
                name="blood_group"
                value={formData.blood_group}
                onChange={handleChange}
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A−</option>
                <option value="B+">B+</option>
                <option value="B-">B−</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB−</option>
                <option value="O+">O+</option>
                <option value="O-">O−</option>
              </Input>
            </Col>
            <Col className="mt-3">
              <Label>Emergency Name 1</Label>
              <Input
                type="text"
                name="emergName1"
                placeholder="Emergency Contact Name"
                value={formData.emergName1}
                onChange={handleChange}
              />
            </Col>
            <Col className="mt-2">
              <Label>Emergency Contact No.1</Label>

              <Input
                type="text"
                name="emergNo1"
                placeholder="Emergency Contact No."
                value={formData.emergNo1}
                onChange={handleChange}
              />
            </Col>
          </FormGroup>
          <Button color="success" onClick={handleUpdate}>
            Update
          </Button>
        </Form>
      </ModalBody>
    </Modal>
  )
}

const ReusableComponent = ({ title, details, setSubmitted }) => {

  const [modalOpen, setOpenModal] = useState(false)

  const handleEdit = () => {
    setOpenModal(true)
  }

  return (
    <div className="mb-3">
      <span className="text-primary fs-4 fw-medium">{title}</span>

      {title === "Personal Details" && (
        <div className="d-flex">
          <i
            onClick={handleEdit}
            className="bx bxs-edit ms-auto"
            style={{
              fontSize: "20px",
              borderRadius: "5px",
              color: "#0d6efd",
              cursor: "pointer",
            }}
          ></i>
        </div>
      )}

      {Object.entries(details).map(([key, value]) => (
        <div
          className="d-flex align-items-start justify-content-between"
          key={key}
        >
          <div className="w-50">
            <span
              style={{
                lineHeight: 2,
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              {key}
            </span>
          </div>
          <div className="w-50">
            <span style={{ lineHeight: "1.2", fontSize: "14px" }}>{value}</span>
          </div>
        </div>
      ))}

      {modalOpen && (
        <MyModal2
          modal={modalOpen}
          toggle={() => setOpenModal(false)}
          values={{
            blood_group: details["Blood Group"] || "",
            emergName1: details["Emergency Name 1"] || "",
            emergNo1: details["Emergency Contact No.1"] || "",
          }}
          setSubmitted={setSubmitted}
        />
      )}
    </div>
  )
}

const Home = () => {
  const [submitted, setSubmitted] = useState(false)
  const token = JSON.parse(localStorage.getItem("Token"))
  const [profileData, setProfileData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [uploaded, setUpload] = useState(false)

  const handleImageUpload = async event => {
    try {
      const file = event.target.files[0]

      if (!file) {
        return
      }
      setUpload(true)
      const formData = new FormData()
      formData.append("files", file)

      const response = await axios.post(
        "https://marcopolo.prisms.in/api/teacher-profile/update-profile-image",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        }
      )
      if (response.status === 200) {
        toast.success("Image uploaded successfully!")
        setUpload(false)
      } else {
        toast.error("Unexpected error during upload.")
        setUpload(false)
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message || "Server error occurred.")
        setUpload(false)
      } else if (error.request) {
        toast.error("No response from server. Please try again later.")
        setUpload(false)
      } else {
        toast.error("An error occurred. Please try again.")
        setUpload(false)
      }
    }
  }

  useEffect(() => {
    const getTeacherProfile = async () => {
      try {
        const res = await axios({
          method: "GET",
          url: "https://marcopolo.prisms.in/api/teacher-profile/get-profile",
          headers: {
            Authorization: token,
          },
        })

        setProfileData(res.data)
        setLoading(false)
      } catch (error) {
        setError("Failed to load profile data. Please try again.")
        setLoading(false)
      }
    }

    getTeacherProfile()
  }, [token, uploaded, submitted])
  const replaceS3Url = url => {
    const baseUrl = "https://files.prisms.in/"
    const replacementBaseUrl = "https://s3.amazonaws.com/topschool-attachments/"

    const newUrl = url.replace(replacementBaseUrl, baseUrl)
    return newUrl
  }

  const ConvertExp = val => {
    return val / 12
  }

  return (
    <Row className="mt-5 py-4">
      {loading && <Spinners />}
      {error && <div className="alert alert-danger">{error}</div>}

      {!loading && !error && profileData && profileData.length > 0 && (
        <Card className="shadow-lg mx-auto" style={{ maxWidth: "900px" }}>
          <CardBody>
            <div className="text-center mb-3 mt-3">
              <div style={{ position: "relative", display: "inline-block" }}>
                <CardImg
                  src={
                    (profileData[0].photo &&
                      replaceS3Url(profileData[0]?.photo)) ||
                    "https://ocisa.prisms.in/images/dashboard/student.png"
                  }
                  id="profileImage"
                  alt="Profile"
                  className="rounded-circle"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                />

                <Input
                  type="file"
                  accept="image/png, image/jpeg, image/jpg"
                  id="profileUpload"
                  style={{ display: "none" }}
                  onChange={handleImageUpload}
                />

                <label
                  htmlFor="profileUpload"
                  style={{
                    position: "absolute",
                    bottom: -4,
                    right: 5,
                    backgroundColor: "#007bff",
                    color: "white",
                    padding: "8px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    border: "2px solid white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "32px",
                    height: "32px",
                  }}
                >
                  <i className="fa fa-camera" style={{ fontSize: "16px" }} />
                </label>
              </div>

              <h5 className="text-center text-primary mt-4">
                {profileData[0].first_name &&
                  profileData[0].first_name + " " + profileData[0].last_name}
              </h5>
              <h6 className="text-center">
                {profileData && profileData[0].type}
              </h6>
            </div>

            <ReusableComponent
              title="General Details"
              details={{
                Username: profileData[0] && profileData[0].username,
                Email: profileData[0].email_id,
                "Mobile No": profileData[0].contact1,
                "Date of Birth":
                  profileData[0].dob &&
                  moment(profileData[0].dob).format("DD-MM-YY"),
                "Address Line 1":
                  profileData[0].address_line1,
                       "Address Line 2":
                  profileData[0].address_line2,
                  // `${profileData[0].address_line1}, ${profileData[0].address_line2}`,
                City: profileData[0].city,
                State: profileData[0].state,
                Country: profileData[0].country,
                Pincode: profileData[0].pincode,
              }}
            />

            <ReusableComponent
              title="Personal Details"
              details={{
                "Joining Date":
                  profileData[0].joining_date &&
                  moment(profileData[0].joining_date).format("DD-MM-YY"),
                Experience:
                  profileData[0].experience &&
                  `${ConvertExp(profileData[0].experience).toFixed(1)} Years`,
                "Blood Group": profileData[0].blood_group,
                "Emergency Contact No.1": profileData[0].emergNo1,
                "Emergency Name 1": profileData[0].emergName1,
              }}
              setSubmitted={setSubmitted}
            />

            <div className="mb-3">
              <span className="text-primary fs-4 fw-medium">Subjects</span>
              {profileData[0] &&
                profileData[0].subjects &&
                profileData[0].subjects.map((subject, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-start justify-content-between"
                  >
                    <div className="w-50">
                      <span
                        style={{
                          fontWeight: 600,
                          lineHeight: 2,
                          fontSize: "14px",
                        }}
                      >
                        {subject.subject_name} ({subject.full_division_name})
                      </span>
                    </div>
                    <div className="w-50">
                      <span
                        style={{
                          lineHeight: 2,
                          fontSize: "14px",
                        }}
                      >
                        {subject.is_classteacher ? (
                          <span className="text-success fw-bold">
                            Class Teacher
                          </span>
                        ) : (
                          "Teacher"
                        )}
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          </CardBody>
        </Card>
      )}
      <ToastContainer />
    </Row>
  )
}

export default Home
